import { Pipe, PipeTransform } from '@angular/core';
import { formatDurationExact } from '../../utils/duration-exact.util';

@Pipe({
  standalone: false,
  name: 'bringozDurationExact'
})
export class BringozDurationExactPipe implements PipeTransform {

  transform(duration: number): string {
    return formatDurationExact(duration);
  }
}
